// extracted by css-extract-rspack-plugin
export default {"cls1":"VideoPlayerMainContent-cls1_9Ml","cls2":"VideoPlayerMainContent-cls2_NzV VideoPlayerMainContent-cls1_9Ml"};